module.exports = __webpack_public_path__ + "img/qm4.4009a900.jpg";